module.exports = __webpack_public_path__ + "img/icons B_14.293f9740.svg";